const system_limit = {
    limit_exceeded: '您已達到系統限制，請聯絡支援以取得協助。',
};
export default Object.freeze(system_limit);
